import * as React from 'react';

import { useIntl } from 'react-intl';

import { generalMessages } from 'src/utils/messages';

import type { InParkingCard, InParkingCardDetail } from 'src/features/cards/types/card';

const useCalculateStayTime = () => {
    const { formatMessage } = useIntl();

    const calculateStayTime = React.useCallback((cardData?: InParkingCardDetail | InParkingCard | null) => {
        if (!cardData) {
            return '';
        }

        const enterDateTime = cardData.enter_datetime ? new Date(cardData.enter_datetime) : new Date();
        const currentTimestamp = new Date().getTime();

        const currentStay = currentTimestamp - enterDateTime.getTime();
        const stayTime = {
            days: '',
            hours: '',
            minutes: '',
        };

        const days = Math.floor(currentStay / (1000 * 60 * 60 * 24));
        // If we don't have a day, we don't need to show it, so we can remove it from the string
        stayTime.days = days > 0 ? `${days} ${formatMessage(generalMessages.days)}, ` : '';
        const hours = Math.floor((currentStay % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        stayTime.hours = hours > 0 ? `${hours} ${formatMessage(generalMessages.hours)}, ` : '';
        const minutes = Math.floor((currentStay % (1000 * 60 * 60)) / (1000 * 60));
        stayTime.minutes = minutes > 0 ? `${minutes} ${formatMessage(generalMessages.minutes)}` : '';

        const stayString = `${stayTime.days}${stayTime.hours}${stayTime.minutes}`;
        return stayString;
    }, []);

    return { calculateStayTime };
};
export default useCalculateStayTime;
